<template>
  <base-layout
    :readOnly="readOnly"
    :value="value"
    :label-width="labelWidth"
    :text-align="textAlign"
    :style-type="styleType"
    :is-require="isRequire"
    :label="label"
    :is-dipatch="isDipatch"
    :is-dipatch-style="isDipatchStyle"
    :labelPaddingRight = "labelPaddingRight"
    :whiteSpace="whiteSpace"
  >
    <el-input-number
      :clearable="true"
      :icon="icon"
      @blur="handleEmitBlur"
      @keyup.enter.native="handleEmitEnter"
      slot="control"
      :autofocus="autofocus"
      :disabled="disabled"
      @input="handleEmitValue"
      v-model="inputValue"
      :placeholder="placeholder"
      :step="step"
      :min="min"
      :max="max"
      ref="input"
      controls-position="right"
    ></el-input-number>
  </base-layout>
</template>

<script>
import baseLayout from "./base-layout.vue";
import {
  handleEmitValue,
  string,
  handleEmitBlur,
  handleEmitEnter
} from "./../props-config";
import Vue from "vue";
export default {
  name: "base-string",
  components: {
    baseLayout
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        if (this.isDipatch) {
          this.$store.dispatch("updateObject", {
            obj: this.dipatchObj,
            attr: this.dipatchAttr,
            val: val
          });
        }
        this.$emit("input", val);
      }
    }
  },
  props: {
    ...string,
    type: {
      type: String,
      default: "text"
    },
    handleIconCLick: {
      type: Function,
      default: () => {}
    },
    multiple: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    step: {
      type: Number
    },
    whiteSpace: {
      type: Boolean
    }
  },
  mounted() {},
  methods: {
    handleFocus() {
        this.$refs['input'].$el.children[1].focus()
    },
    handleEmitValue,
    handleEmitBlur,
    handleEmitEnter
  },
  data() {
    return {
      dialogConfig: {
        value: ""
      },
      _emit: null
    };
  }
};
</script>
<style>
  .el-input-number {
    width: 100% !important;
  }
</style>
